export enum PartTypeUIMessages {
  UPDATE_PART_TYPE_SUCCESS = 'Part Type successfully updated.',
  UPDATE_PART_TYPE_ERROR = 'An error occurred while updating the Part Type.',
  LOAD_PART_TYPE_LIST_ERROR = 'An error occurred while loading the list of Part Types.',
  LOAD_PART_TYPE_ERROR = 'An error occurred while loading the Part Type.',
  ADD_PART_TYPE_SUCCESS = 'Part Type successfully created.',
  ADD_PART_TYPE_ERROR = 'An error occurred while creating the Part Type.'
}
